import React from "react";
import {
  useDeleteCategoryMutation,
  useFetchCategoriesQuery,
} from "../../../../store";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { categoryColumns } from "../utils/categoryColumn";
import ManagementToolbar from "../../managementShared/ManagementToolbar";
import {
  CATEGORY_DIALOG,
  CONFIRM_DIALOG,
} from "../../../../store/slices/utils/dialogEnum";
import { useDispatch, useSelector } from "react-redux";
import { setCategory } from "../../../../store/slices/applicationManagement/managementSlice";
import {
  closeDialog,
  openDialog,
} from "../../../../store/slices/dialog/dialogSlice";
import {
  openErrorToast,
  openSuccessToast,
} from "../../../../store/slices/toast/toastSlice";
import CustomConfirmDialog from "../../../../components/shared/CustomConfirmDialog";
import CategoryForm from "./CategoryForm";
import ListHeader from "../../managementShared/ListHeader";

const Category = () => {
  const dispatch = useDispatch();
  const { data: categories, isLoading: categoryLoading } =
    useFetchCategoriesQuery();
  const { categoryDialogOpen } = useSelector((state) => state.dialogSlice);
  const { category } = useSelector((state) => state.managementSlice);
  const [deleteCategory, { isLoading: deleteLoading }] =
    useDeleteCategoryMutation();

  const handleUpdate = (category) => {
    dispatch(setCategory(category));
    dispatch(openDialog(CATEGORY_DIALOG));
  };

  const handleDelete = (category) => {
    dispatch(setCategory(category));
    dispatch(openDialog(CONFIRM_DIALOG));
  };

  const closeDelete = () => {
    dispatch(setCategory(null));
    dispatch(closeDialog(CONFIRM_DIALOG));
  };

  const postDelete = () => {
    deleteCategory(category.id).then((res) => {
      if (res) {
        if (!res.data.isSuccess) {
          dispatch(openErrorToast(res.data.message));
        } else {
          dispatch(openSuccessToast("İşlem Tamamlandı"));
          closeDelete();
        }
      }
    });
  };

  return (
    <Box
      sx={{
        height: 300,
        width: "100%",
        marginTop: 10,
        flex: "flex",
        flexDirection: "column",
      }}
    >
      <ListHeader text="Kategoriler" />
      {category && (
        <CustomConfirmDialog
          handleConfirm={postDelete}
          title="Kategori Silme Onayı"
          text="Bu kategoriyi silmek istediğinize emin misiniz?"
          isLoading={deleteLoading}
          handleClose={closeDelete}
        />
      )}
      {categoryDialogOpen && <CategoryForm />}
      <DataGrid
        rows={categories?.data || []}
        loading={categoryLoading}
        disableColumnMenu
        columns={categoryColumns(handleUpdate, handleDelete)}
        pageSizeOptions={[5, 10, 25, 50]}
        disableRowSelectionOnClick
        slots={{
          toolbar: (props) => (
            <ManagementToolbar {...props} dialogType={CATEGORY_DIALOG} />
          ),
        }}
        showToolbar
      />
    </Box>
  );
};

export default Category;
